import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgButtonPress = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14.5 15H13C11.8954 15 11 14.1046 11 13V11C11 9.89543 11.8954 9 13 9H25C26.1046 9 27 9.89543 27 11V13C27 14.1046 26.1046 15 25 15H24",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M29 31V22C29 20.9 28.1136 20 27.0302 20H21.121V14C21.121 12.9 20.2346 12 19.1512 12C18.0679 12 17.1815 12.9 17.1815 14V25L14.5223 22.9C13.7344 22.3 12.7495 22.1 11.8632 22.5C11.0752 22.8 10.7798 23.7 11.1737 24.3L15.2117 31",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	})]
});
const ForwardRef = forwardRef(SvgButtonPress);
export default ForwardRef;
